import router from './index'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { asyncRoutes } from './routes'

// 白名单路由，无需认证
const WHITE_LIST = ['/login', '/404']

// 标记动态路由是否已添加
let hasAddedRoutes = false

/**
 * 重置路由（用于登出后重新登录）
 */
export function resetRouter() {
  hasAddedRoutes = false
}

router.beforeEach(async (to, from, next) => {
  const token = getToken()

  if (token) {
    if (to.path === '/login') {
      // 已登录状态下访问登录页，重定向到首页
      next({ path: '/' })
    } else {
      // 检查是否已获取用户信息
      const hasUserInfo = store.state.user.userInfo
      if (hasUserInfo) {
        next()
      } else {
        try {
          // 获取用户信息
          await store.dispatch('user/getUserInfo')

          // 动态添加需权限的路由
          if (!hasAddedRoutes) {
            router.addRoutes(asyncRoutes)
            hasAddedRoutes = true
          }

          // hack：确保 addRoutes 已完成
          next({ ...to, replace: true })
        } catch (error) {
          // 获取用户信息失败，清除 Token 并跳转登录
          await store.dispatch('user/resetToken')
          next(`/login?redirect=${to.path}`)
        }
      }
    }
  } else {
    // 未登录
    if (WHITE_LIST.includes(to.path)) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})
